import { Controller } from "@hotwired/stimulus"
import { computePosition, flip, shift, offset, arrow } from "@floating-ui/dom"

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "top" }
  }

  connect() {
    this.createTooltip()
    this.element.addEventListener("mouseenter", this.show)
    this.element.addEventListener("mouseleave", this.hide)
    this.element.addEventListener("focus", this.show)
    this.element.addEventListener("blur", this.hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.show)
    this.element.removeEventListener("mouseleave", this.hide)
    this.element.removeEventListener("focus", this.show)
    this.element.removeEventListener("blur", this.hide)
    this.tooltip?.remove()
  }

  createTooltip() {
    this.tooltip = document.createElement("div")
    this.tooltip.className = "tooltip"
    this.tooltip.setAttribute("role", "tooltip")
    const content = document.createElement("span")
    content.className = "tooltip-content"
    content.textContent = this.contentValue
    const arrowDiv = document.createElement("div")
    arrowDiv.className = "tooltip-arrow"
    this.tooltip.appendChild(content)
    this.tooltip.appendChild(arrowDiv)
    this.tooltip.style.display = "none"
    document.body.appendChild(this.tooltip)
    this.arrowEl = this.tooltip.querySelector(".tooltip-arrow")
  }

  show = async () => {
    this.tooltip.style.display = "block"
    await this.updatePosition()
  }

  hide = () => {
    this.tooltip.style.display = "none"
  }

  async updatePosition() {
    const { x, y, placement, middlewareData } = await computePosition(
      this.element,
      this.tooltip,
      {
        placement: this.placementValue,
        middleware: [
          offset(8),
          flip(),
          shift({ padding: 8 }),
          arrow({ element: this.arrowEl })
        ]
      }
    )

    Object.assign(this.tooltip.style, {
      left: `${x}px`,
      top: `${y}px`
    })

    // Position the arrow
    const { x: arrowX, y: arrowY } = middlewareData.arrow || {}
    const staticSide = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[placement.split("-")[0]]

    Object.assign(this.arrowEl.style, {
      left: arrowX != null ? `${arrowX}px` : "",
      top: arrowY != null ? `${arrowY}px` : "",
      right: "",
      bottom: "",
      [staticSide]: "-4px"
    })

    this.tooltip.dataset.placement = placement
  }
}
